import React from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

const CustomTextField = styled((props) => <TextField {...props} />)(({ theme }) => ({
  '& .MuiOutlinedInput-input::-webkit-input-placeholder': {
    color: theme.palette.text.secondary,
    opacity: '0.8'
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[200]
  },
  '& .MuiOutlinedInput-input.Mui-disabled::-webkit-input-placeholder': {
    color: theme.palette.text.secondary,
    opacity: '1'
  },
  '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[200]
  },
  '& textarea': {
    padding: '0 !important'
  },

  // СТИЛИ ДЛЯ READONLY ЧЕРЕЗ АТРИБУТ
  '& .MuiOutlinedInput-root input[readonly]': {
    backgroundColor: 'transparent',
    cursor: 'default',
    '& ~ .MuiOutlinedInput-notchedOutline': {
      borderStyle: 'none'
    }
  },

  // Более специфичные стили
  '& .MuiOutlinedInput-root:has(input[readonly])': {
    backgroundColor: 'transparent',
    cursor: 'default',
    '& .MuiOutlinedInput-input': {
      cursor: 'default',
      color: theme.palette.text.primary,
      opacity: 0.9
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderStyle: 'none'
    }
  }
}));

export default CustomTextField;
